import React, {ReactElement} from 'react';
import {connect} from 'react-redux';
import ReactDOM from 'react-dom';
import {Dispatch} from 'redux';
import {IModal, IState} from '../../interface';
import actions from '../../redux/actions';

export interface IProps {
  className?: string;
  children: ReactElement;
  modal: IModal;
  setModal: (value: IModal) => void;
  dismiss?: () => void;
}

//Modal HOC
function Modal(props: IProps) {
  const {children, className, modal, setModal, dismiss} = props;
  const root = modal.visibie ? document.getElementById('root') : null;
  return root
    ? ReactDOM.createPortal(
        <>
          <div
            className='modal-mask'
            onClick={() => {
              setModal({visibie: false, href: 0});
              dismiss && dismiss();
            }}
          ></div>
          <div className={`modal ${className}`}>
            <div className='modal-container'>{children}</div>
          </div>
        </>,
        root,
      )
    : null;
}

const mapStateToProps = (state: IState) => ({
  modal: state.modal,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
